/**
 * @generated SignedSource<<27d6df0c0d4c9b90335095e6dc5702e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutUIActions_preCheckoutTransaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_preCheckoutTransaction">;
  readonly " $fragmentType": "checkoutUIActions_preCheckoutTransaction";
};
export type checkoutUIActions_preCheckoutTransaction$key = {
  readonly " $data"?: checkoutUIActions_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIActions_preCheckoutTransaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutUIActions_preCheckoutTransaction"
};

(node as any).hash = "b41fe94311c1468a2ca93d457ee95d4e";

export default node;
